// FIN-12208: the "Scoring Overrides" tab never affects Threshold Generation, so the
// generation lock must never disable it. The drawer's `isReadOnly` is set true both by the
// generation lock (generationState 'generating'/'generated') AND by genuine read-only
// viewers (ScoreExplainability / TypologyRulesConfig, which render the drawer with no active
// generation and expect a non-editable view). Decouple ONLY the generation lock: keep
// Scoring Overrides editable throughout generation, while a genuine read-only viewer
// (isReadOnly with no active generation) stays disabled.
//
// Leaf module (no antd/React imports) so the logic is unit-testable in isolation.
export const isScoringOverridesDisabled = (isReadOnly, generationState) => {
  const lockedByGeneration =
    generationState === 'generating' || generationState === 'generated';
  return !!isReadOnly && !lockedByGeneration;
};
